import api from '../services/api';
import getHeaders from '../utils/returnHeaders';

const getFlightPricing = async (data) => {
  const header = getHeaders();

  return api.post(`/flight/pricing`, JSON.stringify(data), header);
};

export default getFlightPricing;
